import * as v from "valibot";

import { CheckInReports } from "@/features/check-in-reports/check-in-reports";
import { CHECK_IN_REPORTS_QUERY } from "@/features/check-in-reports/graphql/check-in-reports-query";

const searchSchema = v.object({
  page: v.pipe(
    v.optional(v.number(), 1),
    v.minValue(1, "page value minimum is 1."),
  ),
  pageSize: v.pipe(
    v.optional(v.number(), 20),
    v.minValue(10, "pageSize value minimum is 10."),
    v.maxValue(100, "pageSize value maximum is 100."),
  ),
  // filters
  name: v.optional(v.string()),
  category: v.optional(v.array(v.string())),
});

export const Route = createFileRoute({
  component: CheckInReports,
  loaderDeps: ({ search: { page, pageSize } }) => ({ page, pageSize }),
  loader: ({ context, params, deps }) => {
    if (context.urqlClient) {
      context.urqlClient.query(CHECK_IN_REPORTS_QUERY, {
        organizationId: params.orgId,
        first: deps.pageSize,
        offset: (deps.page - 1) * deps.pageSize,
      });
    }
  },
  validateSearch: searchSchema,
});
